<template>
    <div>
        <h3 class="mt-2">No. of Entries</h3>
        <!-- filters  -->
        <vs-row>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                <SelectDate :selectedDate.sync="filters.from" label="From" />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                <SelectDate :selectedDate.sync="filters.to" label="To" />
            </vs-col>
        </vs-row>
        <!-- data  -->
        <vx-card class="mt-3 mb-base">
            <vs-table :data="results" slot="no-body" :hoverFlat="true" stripe>
                <vs-tr>
                    <vs-th style="min-width: 110px;">Organisation</vs-th>
                    <vs-th style="min-width: 110px;">Routine Maintence</vs-th>
                    <vs-th style="min-width: 110px;">Electical Maintenance</vs-th>
                    <vs-th style="min-width: 110px;">Major Maintencance</vs-th>
                    <vs-th style="min-width: 110px;">Corrective Maintenance</vs-th>
                    <vs-th style="min-width: 110px;">Road Incident</vs-th>
                    <vs-th style="min-width: 110px;">Encroachment</vs-th>
                    <vs-th style="min-width: 110px;">Safety Program</vs-th>
                </vs-tr>
                <template>
                    <template v-for="(item, index) in results">
                        <vs-tr :key="index">
                            <vs-td>{{ item.name }}</vs-td>
                            <vs-td>{{ item.routine_maintenance + item.rm_dpr_daily_entry + item.rm_dpr_month_entry  }}</vs-td>
                            <vs-td>{{ item.electrical_maintenance }}</vs-td>
                            <vs-td>{{ item.major_maintenance + item.mm_dpr_entry }}</vs-td>
                            <vs-td>{{ item.corrective_maintenance }}</vs-td>
                            <vs-td>{{ item.road_incident }}</vs-td>
                            <vs-td>{{ item.enroachment }}</vs-td>
                            <vs-td>{{ item.safety_program }}</vs-td>
                        </vs-tr>
                    </template>
                </template>
            </vs-table>
        </vx-card>
        <!-- pagination  -->
        <template v-if="!disable_pagination">
            <vs-row v-if="total_results" class="mt-3 text-center">
                <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
            </vs-row>
        </template>
    </div>
</template>

<script>
import { Request } from '../../utils/requests';
import SelectDate from '../../components/letstream/ls-select-date/SelectDate.vue';

export default {
    components: {
        SelectDate
    },
	props: {
        embedded_mode: {
            required: false,
            default: false
        },
        embedded_filters: {
            required: false,
            default: () => {}
        },
        disable_pagination: {
            required: false,
            default: false
        },
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0);
        let limit = parseInt(this.$route.query.limit || 20);
        let current_page = Math.ceil((offset + limit) / limit);

        return  {

            results: [],

			next_url: null,
            loading: false,
            total_results: null,
            current_page: current_page,
            filters: {
                search: this.$route.query.search || null,
                ordering: this.$route.query.ordering || [],
                offset: offset,
                limit: limit,
                from: null,
                to: null,
            },

            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
	computed: {
        total_pages() {
            if(this.total_results == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_results/this.filters.limit)
        },
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {

                if (this.current_page == null) return;

                if (this.timer) clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.$router.push({ name: this.$route.name, query: {...newV, ...this.embedded_query_params} });
                }, 800);
            }
        },
        "$route.query"(newV) {
            this.load_data(newV);
        },
        current_page(newV, oldV) {
            if (newV == oldV) return;
            this.filters.offset = (newV - 1) * this.filters.limit;
        },
    },
    methods: {
        init(){
            this.load_data(this.filters)
        },
        calculate_page() {
            if (this.filters.offset == 0) {
                this.current_page = 1;
            } else {
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit);
            }
        },
        load_data(filters=null) {

            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.entries_report
            let payload = filters

            if (!payload) payload = {};

            if (this.embedded_mode && this.embedded_filters) {
                payload = { ...payload, ...this.embedded_filters };
            }

            this.api_errors = {}

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.results = res.results
                    this.total_results = res.count
                    this.next_url = res.next;
                    this.loading = false;
                    this.$vs.loading.close();
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An Error Occurred, Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        }
    }
}
</script>
